import React from 'react'
import TooltipBanner from './TooltipBanner'

const LEGEND_ITEMS = [
  { label: 'Submitted request', fulldayColor: '#8BC34A' ,partialdayColor: '#8BC34A'},
  { label: 'New request', fulldayColor: '#0074AD', partialdayColor: 'white' },
  { label: 'Adding to new request', fulldayColor: '#9FD0F0' , partialdayColor: 'white'},
  { label: 'Vacation Bidding', fulldayColor: '#FF8A33' , partialdayColor: 'white' },
]

const FullDayIcon = ({ color }: { color: string }) => (
  <span
    className="inline-block h-3.5 w-3.5 rounded-full"
    style={{ backgroundColor: color }}
  />
)

const PartialDayIcon = ({ color }: { color: string }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    aria-hidden="true"
  >
    <path
      d="M6 0A6 6 0 0 0 6 12L6 6Z"
      fill={color}
    />
  </svg>
)

const LegendRow = ({
  label,
  fulldayColor,
  partialdayColor,
}: {
  label: string
  fulldayColor: string
  partialdayColor: string
}) => (
  <div className="flex items-center py-1.5">
    {/* Label */}
    <div className="w-[170px]">
      <span className="p4 -book whitespace-nowrap">
        {label}
      </span>
    </div>

    {/* Full Day */}
    <div className="flex w-16 justify-center">
      <FullDayIcon color={fulldayColor} />
    </div>

    {/* Partial Day */}
    <div className="flex w-16 justify-center">
      <PartialDayIcon color={partialdayColor} />
    </div>
  </div>
)

/**
 * Color legend tooltip used next to the Select Dates heading.
 */
const ColorLegendTooltip: React.FC = () => {
  const header = (
    <span className="p2 -medium">
      Color definitions
    </span>
  )

  const message = (
    <div className="flex flex-col gap-4">
      {/* Column headers */}
      <div className="mb-3 flex items-center gap-4">
  <div className="w-[170px]" />

  <div className="w-16 text-center">
    <span className="p4 -medium whitespace-nowrap">
      Full Day
    </span>
  </div>

  <div className="w-16 text-center">
    <span className="p4 -medium whitespace-nowrap">
      Partial Day
    </span>
  </div>
</div>

      {/* Legend rows */}
      {LEGEND_ITEMS.map((item) => (
        <LegendRow
          key={item.label}
          label={item.label}
          fulldayColor={item.fulldayColor}
          partialdayColor={item.partialdayColor}
        />
      ))}
    </div>
  )

  return (
    <TooltipBanner
      header={header}
      message={message}
      width="w-[calc(100vw-2rem)] md:w-[420px]"
      padding="p-4!"
      tooltipContainerClass="left-1/2 -translate-x-1/3 bottom-full mb-2 md:left-full md:translate-x-0 md:bottom-0 md:mb-0 md:ml-2 z-50"
      triggerOnClick
    >
      <button
        type="button"
        aria-label="Color definitions"
        className="ml-3 inline-flex items-center justify-center"
      >
        <img
          src="/assets/images/info-circle-solid.svg"
          alt="Color definitions"
          className="h-8 w-8 ml-3! mt-2! cursor-pointer"
        />
      </button>
    </TooltipBanner>
  )
}

export default ColorLegendTooltip